import React from 'react';

interface OGBadgeProps {
  className?: string;
  large?: boolean;
  big?: boolean;
}

const OGBadge: React.FC<OGBadgeProps> = ({ className = '', large = false, big = false }) => (
  <span
    className={`og-badge relative inline-flex shrink-0 items-center justify-center overflow-hidden rounded-full border border-yellow-400/80 bg-black font-black text-yellow-400 shadow-[0_0_10px_rgba(234,179,8,0.55)] ${large ? 'h-20 w-20 text-3xl' : big ? 'h-9 px-3.5 text-base' : 'h-5 px-2 text-[10px]'} ${className}`}
    title="One of the first 50 RIDAZ accounts"
  >
    <span className="relative z-10 tracking-wide" style={{ textShadow: '0 0 6px rgba(234,179,8,0.85)' }}>OG</span>
    <span className="og-badge-shine pointer-events-none absolute inset-0" aria-hidden="true" />
  </span>
);

export default OGBadge;
